import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Check, Clock, X } from "lucide-react";

const PricingCards: React.FC = () => {
  return (
    <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
      {/* Free Plan Card */}
      <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-md">
        <div className="p-6 border-b border-gray-100">
          <h3 className="text-xl font-semibold mb-2">Free Listing</h3>
          <p className="text-3xl font-bold mb-4">€0 <span className="text-base font-normal text-gray-500">/month</span></p>
          <p className="text-gray-600">Get listed with minimal exposure</p>
        </div>
        
        <div className="p-6">
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Basic business profile</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Location on map</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Contact information</span>
            </li>
            <li className="flex items-start gap-2">
              <X size={18} className="text-red-500 mt-0.5" />
              <span className="text-gray-400">Multiple image uploads</span>
            </li>
            <li className="flex items-start gap-2">
              <X size={18} className="text-red-500 mt-0.5" />
              <span className="text-gray-400">Always show contact button</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Auto-on signup trial (14 days)</span>
            </li>
          </ul>
          
          <Button className="w-full bg-sauna-navy hover:bg-sauna-navy/90">
            Sign Up Free
          </Button>
        </div>
      </div>
      
      {/* Premium Plan Card */}
      <div className="border-2 border-sauna-orange rounded-lg overflow-hidden bg-white shadow-lg relative">
        <div className="absolute top-4 right-4">
          <Badge className="bg-sauna-blue">Recommended</Badge>
        </div>
        
        <div className="p-6 border-b border-sauna-orange/10 bg-gradient-to-r from-sauna-orange/5 to-sauna-blue/5">
          <h3 className="text-xl font-semibold mb-2">Premium</h3>
          <div className="flex items-baseline gap-2">
            <p className="text-3xl font-bold mb-0">€49 <span className="text-base font-normal text-gray-500">/month</span></p>
            <Badge className="bg-sauna-beige text-sauna-navy">First Launch Special</Badge>
          </div>
          <div className="flex items-center gap-2 mt-3">
            <Clock size={16} className="text-sauna-blue" />
            <p className="text-sauna-blue font-medium text-sm">14-day free trial - no card required</p>
          </div>
        </div>
        
        <div className="p-6">
          <ul className="space-y-3 mb-6">
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Everything in Free plan</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span><b>10+ images</b> for your gallery</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span><b>Always show contact button</b></span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span><b>Full analytics</b> with visitor insights</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Google rating with links</span>
            </li>
            <li className="flex items-start gap-2">
              <Check size={18} className="text-sauna-green mt-0.5" />
              <span>Top placement with visual card & image</span>
            </li>
          </ul>
          
          <Button className="w-full bg-sauna-orange hover:bg-sauna-orange/90">
            Start 14-Day Free Trial
          </Button>
          <p className="text-xs text-center mt-2 text-gray-500">No credit card required</p>
        </div>
      </div>
    </div>
  );
};

export default PricingCards;
